import { Badge, Box, Group, Stack, Text } from '@mantine/core';
import {
    MOBILE_DEVICE_BRANDS,
    SIM_CARD_TYPES,
} from '../../../../common/enums/enums';

import { getEnumColor } from '../../../../../utils/enumUtils';

const IccidCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    const typeColor = getEnumColor(SIM_CARD_TYPES, rowData.type);
    const brandColor = getEnumColor(
        MOBILE_DEVICE_BRANDS,
        rowData.mobileDevice?.brand
    );

    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>
                    {rowData.iccid}{' '}
                    <Badge
                        size={'xs'}
                        color={typeColor}>
                        {rowData.type}
                    </Badge>
                </Text>
                <Text>
                    {rowData.imei}{' '}
                    <Badge
                        size={'xs'}
                        color={brandColor}>
                        {rowData.mobileDevice?.modelIdentifier}
                    </Badge>
                </Text>
            </Stack>
        </Box>
    );
};

const IccidColumn = () => ({
    accessorKey: 'iccid',
    header: 'Iccid / Imei',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <IccidCell cell={cell} />,
});
export default IccidColumn;
